export enum ScheduleType {
  Anonymous = 1,
  IdentifiedParticipant = 2,
}

export enum ScheduleStatus {
  Draft = 0,
  Active = 1,
  Inactive = 3,
}

export enum TimeScheduleNotificationType {
  Email = 1,
  SMS = 2,
  EmailAndSMS = 3,
}

export enum TimeScheduleSendDateType {
  UseInParticipant = 1,
  UseSelectDate = 2,
}
